document.addEventListener("DOMContentLoaded", function () {
  $('.product-slider').not('.slick-initialized').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    speed: 300
  });

//   document.querySelectorAll('.product-slider .media, .product-slider img').forEach((mediaEl) => {
//     mediaEl.addEventListener('click', function () {
//       const isZoomed = this.classList.contains('zoomed-in');
//       if (isZoomed) {
//         this.classList.remove('zoomed-in');
//         this.style.transform = 'scale(1)';
//       } else {
//         this.classList.add('zoomed-in');
//         this.style.transform = 'scale(2)';
//         this.style.transformOrigin = 'center center';
//       }
//       if (zoomIcon) {
//         zoomIcon.innerHTML = isZoomed
//           ? `<svg><!-- zoom-in SVG --></svg>`
//           : `<svg><!-- zoom-out SVG --></svg>`;
//       }
//     });


// });
  
});
